import { FC, FormEvent, useEffect, useState } from 'react';
import { I18nextProvider, useTranslation } from 'react-i18next';
import Button from 'components/ui/Button/Button';
import FormGroup from 'components/ui/FormGroup/FormGroup';
import { showError } from 'utils/utils';
import { validate } from 'utils/validation';
import { ProposalData } from 'ts/shared/interfaces/ProposalData';
import { i18nTB } from 'utils/shared/utils';
import { resolveLanguageFromProposal } from 'utils/shared/tripResultBuilderPreview';
import { isFlyeastSite, tripBuilderAdditionalInfoValidation } from 'constants/constant';
import { setTripBuilderUnlocked, verifyTripBuilderPassword } from 'utils/shared/tripBuilder';

type TripBuilderClientPasswordLockProps = {
  proposal: ProposalData;
  proposalId: string;
  onUnlock: () => void;
};

const TripBuilderClientPasswordLockView: FC<TripBuilderClientPasswordLockProps> = ({
  proposal,
  proposalId,
  onUnlock,
}) => {
  const { t, i18n } = useTranslation(undefined, { i18n: i18nTB });
  const [password, setPassword] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const isFlyeast = isFlyeastSite();

  useEffect(() => {
    i18n.changeLanguage(resolveLanguageFromProposal(proposal.externalParam_1));
  }, [proposal.externalParam_1, i18n]);

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsSubmitted(true);

    if (!validate({ password: tripBuilderAdditionalInfoValidation.password }, { password })) {
      return;
    }

    setIsLoading(true);

    if (verifyTripBuilderPassword(proposal, password)) {
      setTripBuilderUnlocked(proposalId);
      onUnlock();
    } else {
      showError(t('home.wrong_password'));
    }

    setIsLoading(false);
  };

  return (
    <div className={`main-login ${isFlyeast ? 'main-login-flyeast' : 'main-login-normal'}`} style={{ minHeight: '60vh' }}>
      <div className="main-login-card">
        <h1 className="main-login-title mb-30">{t('password_lock_title')}</h1>

        <form onSubmit={onSubmit}>
          <FormGroup
            onChange={setPassword}
            value={password}
            label={t('login.password')}
            validation={tripBuilderAdditionalInfoValidation.password}
            isSubmitted={isSubmitted}
            type="password"
            name="password"
          />
          <Button
            title={t('login.login')}
            className="btn btn-primary w100p btn-st"
            disabled={isLoading}
          />
        </form>
      </div>
    </div>
  );
};

const TripBuilderClientPasswordLock: FC<TripBuilderClientPasswordLockProps> = (props) => (
  <I18nextProvider i18n={i18nTB}>
    <TripBuilderClientPasswordLockView {...props} />
  </I18nextProvider>
);

export default TripBuilderClientPasswordLock;
